@if (this.errorsDescription$ | async; as errors) {
  @if (errors.root.count > 0 || errors.children) {
    <ul>
      @if (errors.root.count > 0) {
        <li translate>
          @if (errors.root.groupName) {
            <span>
              @if (this.isCustomErrors) {
                {{ errors.root.groupName }}
              } @else {
                {{ (entity + '_LBL_' + errors.root.groupName | uppercase) | translate | translate }}
              }
            - </span>
          }
          <span translate
          [translateParams]="{count: errors.root.count}">{{ errors.root.count === 1 ? 'TOAST_LBL_VALIDATION_ERROR' : 'TOAST_LBL_VALIDATION_ERRORS' }}</span>
          <ul>
            @for (field of errors.root.fieldName; track field) {
              <li>
                @if (this.isCustomErrors) {
                  <span translate>{{ field }}</span>
                } @else {
                  <span translate>{{ (entity + '_LBL_' + field | uppercase) | translate | translate }}</span>
                }
              </li>
            }
          </ul>
        </li>
      }
      @for (error of errors.children; track error) {
        @if (error.count > 0) {
          <li
            >
            @if (error.groupName) {
              <span
                >
                @if (this.isCustomErrors) {
                  {{ error.groupName }}
                } @else {
                  {{ (entity + '_LBL_' + error.groupName | uppercase) | translate | translate }}
                }
              - </span>
            }
            <span translate
            [translateParams]="{count: error.count}">{{ error.count === 1 ? 'TOAST_LBL_VALIDATION_ERROR' : 'TOAST_LBL_VALIDATION_ERRORS' }}</span>
            <ul>
              @for (field of error.fieldName; track field) {
                <li
                  >
                  @if (this.isCustomErrors) {
                    {{ field }}
                  } @else {
                    {{ (entity + '_LBL_' + field | uppercase) | translate | translate }}
                  }
                </li>
              }
            </ul>
          </li>
        }
      }
    </ul>
  }
}
